import React from "react";

export class StepLabel {
  label: string;
  caption?: string;
  cssClasses: Array<string>;

  constructor(label: string, description?: string, cssClasses?: Array<string>) {
    this.label = label;
    if (description) {
      this.caption = description;
    }
    if (cssClasses) {
      this.cssClasses = cssClasses;
    } else {
      this.cssClasses = [];
    }
  }
}

export enum StepStatus {
  Completed,
  Current,
  Pending,
}

interface Props {
  step: StepLabel;
  status: StepStatus;
}

export const Step = (props: Props) => {
  const stepClasses =
    props.status === StepStatus.Pending
      ? [...props.step.cssClasses, "success"]
      : props.status === StepStatus.Current
      ? [...props.step.cssClasses, "active"]
      : [...props.step.cssClasses, "inactive"];

  const stepCurrent = props.status === StepStatus.Current ? "step" : undefined;

  const dataStepLabel = props.step.label
    .toLowerCase()
    .trim()
    .replace(/[^a-z]/, "-");
  const caption = props.step.caption ? (
    <div className="caption">
      <div className="hidden-xs hidden-sm">
        <span>{props.step.caption}</span>
      </div>
    </div>
  ) : null;

  return (
    <li
      className={stepClasses.join(" ")}
      data-step={dataStepLabel}
      aria-current={stepCurrent}
      aria-controls={"input-section-" + props.step.label}
    >
      <div>
        <div className="step">
          <span className="sr-only">
            {props.status === 2
              ? "Completed Step"
              : props.status === 0
              ? "Pending Step"
              : ""}
          </span>
          <span className="label">{props.step.label}</span>
        </div>
        {caption}
      </div>
    </li>
  );
};
